<template>
  <pf-description-list-group v-if="totali[durata].scontato > 0">
    <pf-description-list-term v-if="$props.new">
      {{ $t('Nuovo totale a te riservato') }}
    </pf-description-list-term>
    <pf-description-list-term v-else>
      {{ $t('Totale attuale a te riservato') }}
    </pf-description-list-term>
    <pf-description-list-description class="pf-v6-u-text-align-end">
      <s v-if="hasSconto">
        {{ $currency(totali[durata].listino, currency) }}
      </s>
      {{ $currency(totali[durata].scontato, currency) }} / {{ $t(durata) }}
    </pf-description-list-description>
  </pf-description-list-group>
</template>

<script lang="ts" setup>
import type { OfferTotals } from "@/resources";
import { computed } from "vue";

const props = defineProps<{
  new?: boolean;
  totali: OfferTotals;
  durata: 'Annuale' | 'Mensile' | 'Una tantum';
  currency: 'CHF' | 'EUR',
}>();

const hasSconto = computed(() => props.totali[props.durata].listino != props.totali[props.durata].scontato);
</script>
